import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Luggage03 = function Luggage03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M8 21V7c0-.93 0-1.395.1022-1.7765a3 3 0 0 1 2.1213-2.1213C10.605 3 11.07 3 12 3s1.395 0 1.7765.1022a3 3 0 0 1 2.1213 2.1213C16 5.605 16 6.07 16 7v6.5m0 4V21m-9.2 0h10.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C22 18.7202 22 17.8802 22 16.2v-4.4c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C19.7202 7 18.8802 7 17.2 7H6.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C2 9.2798 2 10.1198 2 11.8v4.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C4.2798 21 5.1198 21 6.8 21m6-3.5h4.9c.28 0 .42 0 .527-.0545a.5.5 0 0 0 .2185-.2185c.0545-.107.0545-.247.0545-.527v-2.4c0-.28 0-.42-.0545-.527a.5.5 0 0 0-.2185-.2185C18.12 13.5 17.98 13.5 17.7 13.5h-4.9c-.28 0-.42 0-.527.0545a.5.5 0 0 0-.2185.2185C12 13.88 12 14.02 12 14.3v2.4c0 .28 0 .42.0545.527a.5.5 0 0 0 .2185.2185c.107.0545.247.0545.527.0545"
    })
  }));
};
export default Luggage03;